import { useCallback, useState } from 'react';

import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../categories/categoriesTypes';

export interface ComposerProductsDockCategory {
  id: CategoryID;
  localizedName: CategoryLocalizedName;
}

// Local mirror of useThreeDStockProductsContentCheckedCategories, but backed by
// component-local state instead of the global StockCache.checkedProductsCategories
// react-query key. That global key is shared with the main stock library page;
// since this is only the "which category tree node is expanded" UI state, keeping
// the dock's copy local avoids the dock and the main library page fighting over a
// shared value when both are mounted.
function useComposerProductsDockCategories() {
  const [checkedCategories, setCheckedCategories] = useState<
    ComposerProductsDockCategory[]
  >([]);

  const clearCheckedCategories = useCallback<() => void>(() => {
    setCheckedCategories([]);
  }, []);

  return {
    checkedCategories,
    setCheckedCategories,
    clearCheckedCategories
  };
}

export { useComposerProductsDockCategories };

export default useComposerProductsDockCategories;
